// A review flag's reason in plain words (the office's Review, and the checklist's blocking line
// that names each open flag): shared, so the server's words and the screen's are the same.

export const FLAG_TEXT: Record<string, string> = {
  material_without_truck: 'A material was used from a truck with none on record',
  low_rating: 'The customer gave a low rating',
  stale_time: 'A time entry reached the office late',
  clock_clamped: 'A device clock was off, so its time was corrected',
  arrived_without_dispatch: 'The technician arrived without being dispatched',
  undo_arrive_too_late: 'An "undo arrive" came too late to apply',
  form_after_cancel: 'A form was filled in after the visit was cancelled',
  media_after_cancel: 'Photos arrived after the visit was cancelled',
  form_answers_do_not_fit: 'Form answers no longer fit the form',
  tech_asked_to_hide: 'The technician asked the office to hide a photo',
  unknown_non_job_code: 'Non-job time with a code the company doesn’t use',
  consent_missing: 'A message was held: the customer hasn’t agreed to texts',
  quiet_hours: 'A message waited for quiet hours to end',
  note_on_cancelled_job: 'A note came in after the job was cancelled',
  video_upload_failed: 'A video didn’t arrive as the technician took it',
};

/** Plain words for a review flag's reason. */
export function flagText(reason: string): string {
  const known = FLAG_TEXT[reason];
  if (known) return known;
  const words = reason.replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** "Open: the technician asked the office to hide a photo; a time entry reached the office late." */
export function openFlagsLine(reasons: readonly string[]): string {
  const words = reasons.map((r) => {
    const t = flagText(r);
    return t.charAt(0).toLowerCase() + t.slice(1);
  });
  return `Open: ${words.join('; ')}.`;
}
